// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionRulesMaybe_root__1ym9Y","title":"SectionRulesMaybe_title__1hiSw","rules":"SectionRulesMaybe_rules__KCXbx"};